// test189
(189 && 0);
